import React, { Component } from 'react';
import { connect } from 'react-redux'
import { changeAreaNum, resetAreasDialog } from '../actions/areas'
import MySnackbar from './MySnackbar'

class AreaTable extends Component {
    // renderErrors(){
    //     for(let k of Object.keys(areas.errors) ){
    //         return (
    //             areas.errors[k].msg ?
    //             <MySnackbar
    //                 key={k}
    //                 variant="error"
    //                 message={areas.error}
    //             />:null
    //         )
    //     }
    // }
    render() {
        const { areas, maxPostNum, optionsAreaNote } = this.props
        const formatter = new Intl.NumberFormat('ja-JP');
        const sumMaxNum = ( areas.sumMaxNum < maxPostNum )?areas.sumMaxNum:maxPostNum
        const defaultNote = '※エリア間隔が離れている注文は、配布単価が変わる場合がございます';
        const notes = [defaultNote];
        if( optionsAreaNote ){
            optionsAreaNote.forEach(note => {
                notes.push(note)
            });
        }
        return (
            <div className="AreaTableComponent">
								<button className='clearButton' onClick={()=>this.props.resetAreasDialog(true)}>全クリア</button>
                <table className="areaTable">
                    <thead>
                        <tr className='labelRow'>
                            <th colSpan="3">
															<div className="labelTableHead">
																<div className="areaNameLabel">エリア名</div>
																<div className="areaNumLabel" colSpan="2">
																		<span className='areaInputLabel'>希望配布部数（部数変更可）</span><span className='areaMaxLabel'>/配布可能部数</span>
																</div>
															</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (areas.list.length === 0)?
                            <tr>
                                <td className="note" colSpan="3">
                                    <span>地図から配布エリアを選択してください</span>
                                </td>
                            </tr>:null
                        }
                        {
                            areas.list.map((area,key)=>(
															<React.Fragment key={Number(area.id)}>
																<tr error={(area.error)?"true":null}>
																		<td className="areaNameCol">
																				<span>{area.name}</span>
																		</td>
																		<td className="areaNumCol">
																				<span>
																						<input
																								type="text"
																								defaultValue={area.num / process.env.REACT_APP_POST_NUM_SHIFT}
																								onChange={(e)=>this.props.changeAreaNum(area.id, e.target.value, area.maxNum)}
																								error={(area.error)?"true":null}
																						/>0部
																				</span>
																		</td>
																		<td className="areaMaxNumCol">
																				<span>/{formatter.format(area.maxNum)}部</span>
																		</td>
																</tr>
																{
																	(area.error)?
																	<tr className='areaError'>
																		<td colSpan={3}>
																			<span>{area.error}</span>
																		</td>
																	</tr>:null
																}
															</React.Fragment>
                            ))
                        }
                        <tr>
                            <td className="areaNameCol">
                                <span>合計</span>
                            </td>
                            <td className="areaNumCol" error={(areas.error)?"true":null}>
                                <span>{formatter.format(areas.sumNum)}部</span>
                            </td>
                            <td className="areaMaxNumCol" error={(areas.error)?"true":null}>
                                <span>/{formatter.format(sumMaxNum)}部</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="selectedAreaNote">
                    {
                        notes.map((note,key)=>(<p key={key}>{note}</p>))
                    }
                </div>
                {
                    areas.list.map((area,key)=>(
                        area.error?
                        <MySnackbar
                            key={key}
                            variant="error"
                            message={area.error}
                        />:null
                    ))
                }
                {
                    Object.keys(areas.errors).map( k =>(
                        areas.errors[k]?
                        <MySnackbar
                            key={k}
                            variant="error"
                            message={areas.errors[k]}
                        />:null
                    ))
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    // member: state.members.one,
    areas: state.areas,
    maxPostNum: state.options.rules.maxPostNum,
		optionsAreaNote: state.options.areaNotes,
})

const mapDispatchToProps = dispatch => ({
    // readTest: () => dispatch(readTest()),
    // readTest: readTest(),
    changeAreaNum: (id,num,maxNum) => dispatch(changeAreaNum(id,num,maxNum)),
    resetAreasDialog: (open) => dispatch(resetAreasDialog(open)),
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AreaTable);



// WEBPACK FOOTER //
// ./src/components/AreaTable.js